export const servicesSuspendPolicy = {
  compute_nova: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
    {keyword: 'suspendInstances', value: 'suspend', default: false},
  ],
  volumes_cinder: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
  ],
  images_glance: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
  ],
  networks_neutron: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
  ],
  identity_keystone: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
  ],
  dns_designate: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
  ],
  loadbalancers_octavia: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
  ],
}

export const servicesFinalPolicy = {
  compute_nova: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
    {keyword: 'shelveOffloadInstances', value: 'shelve', default: false}
  ],
  volumes_cinder: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
    {keyword: 'deleteAllPaidResources', value: 'delete', default: false},
  ],
  images_glance: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
    {keyword: 'deleteAllPaidResources', value: 'delete', default: false},
  ],
  networks_neutron: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
    {keyword: 'deleteAllPaidResources', value: 'delete', default: false},
  ],
  identity_keystone: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
  ],
  dns_designate: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
    {keyword: 'deleteAllPaidResources', value: 'delete', default: false},
  ],
  loadbalancers_octavia: [
    {keyword: 'keepResourcesUntouched', value: 'keep', default: true},
    {keyword: 'deleteAllPaidResources', value: 'delete', default: false},
  ],
}